import React from 'react'
import { Grid } from '@material-ui/core'
import AddBtn from 'components/AddBtn'

export default function Toolbar (props) {
  return (
    <div className={'tool-bar'}>
      <Grid container spacing={2}>
        <Grid item xs={12} container justify='flex-end'>
          <AddBtn
            color='primary'
            type='submit'
            style={{marginRight: 0}}
            onClick={e => {
              e.stopPropagation()
              props.history.push(`/feature-banner/placements/add`)
            }}
            variant='contained'
          >
            Add
          </AddBtn>
        </Grid>
      </Grid>
    </div>
  )
}
